export const MESSAGES = {
  required: "Please fill out this field",
  email: "Please enter a valid email address",
  password_length: "Password must be at least 12 characters long",
};
